import template from 'text!./ContactRoleAdditionalInterest.html';
import controller from './ContactRoleAdditionalInterestCtrl';

export default {
    template,
    controller,
    bindings: {
        roleType: '@',
        roleModel: '<'
    }
};
